import React, { ButtonHTMLAttributes, ReactNode } from 'react';
import { IconButton as MuiIconButton } from '@material-ui/core';

interface ButtonIconProps {
  children: ReactNode;
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
  busy?: boolean;
  disabled?: boolean;
  color?: 'default' | 'inherit' | 'primary' | 'secondary';
  size?: 'small' | 'medium';
  onClick?: () => void;
}

const ButtonIcon = ({ children, type, color, size, busy, disabled, onClick }: ButtonIconProps) => (
  <MuiIconButton color={color} size={size} type={type} disabled={busy || disabled} onClick={onClick}>
    {children}
  </MuiIconButton>
);

export default ButtonIcon;
